<svg *ngIf="!avatarUrl" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 90 90">
	<text x="45" y="50" text-anchor="middle" alignment-baseline="middle" class="initials" fill="#999999">{{initials}}</text>
</svg>
<div *ngIf="avatarUrl" class="avatar" [ngStyle]="{ 'background-image': 'url(' + avatarUrl + ')' }"></div>
